// import React from "react";
// import { Fade, Zoom } from "react-reveal";
// import { Helmet } from "react-helmet";

// import Header from "../../includes/home/Header";
// import styled from "styled-components";
// import Footer from "../../includes/home/Footer";
// import bg from "../../../assets/images/about/AboutBanner.jpg";
// import tab_bg from "../../../assets/images/about/Banner_Tab.jpg";
// import mob_bg from "../../../assets/images/about/Banner_Mob.jpg";
// import aboutImg from "../../../assets/images/about/Aboutimage.jpg";
// import grp from "../../../assets/images/about/grp.jpg";

// const cardsData = [
//   {
//     title: "Tailored Courses for All Learners",
//     description:
//       "We offer English training classes for every level—beginner to advance. Whether you are a student, a job seeker or a homemaker, we provide training to accomplish your goals. Our step-by-step approach makes learning smooth and stress-free.",
//   },
//   {
//     title: "Trusted IELTS Coaching Centre",
//     description:
//       "We offer IELTS training for academic and general exams. We offer IELTS Coaching Centre like practice tests and live sessions. You’ll build the skills needed for reading, writing, speaking, and listening. With us, you can prepare well and aim high.",
//   },
//   {
//     title: "Beginner-Friendly Spoken English",
//     description:
//       "New to English? Our English speaking course for beginners helps you build a strong base. From greetings to full talks, we guide you through real-life situations. Our trainers make sure you speak with ease and confidence",
//   },
//   {
//     title: "Flexible Online Learning",
//     description:
//       "Want to learn English online on your schedule? Our spoken English classes online and English language course online give you that freedom. Learn from anywhere with expert trainers who keep you motivated and moving forward.",
//   },
// ];

// function AboutPage() {
//   return (
//     <>
//       <Helmet>
//         <title>About English Cafe | English Training Centre in Calicut</title>
//         <meta
//           name="description"
//           content="At English Cafe, we welcome you to boost your confidence and communication skills through our expertly crafted lessons. Join us now!"
//         ></meta>
//       </Helmet>
//       <Container>
//         <Banner>
//           <Header />
//           <Zoom>
//             <Text>About</Text>
//           </Zoom>
//         </Banner>
//         <Fade bottom>
//           <Content>
//             <Wrapper>
//               <SubTitle>About</SubTitle>
//               <CoverTop>
//                 <LeftSection>
//                   <TitleText>English Cafe Stands Out Because...?</TitleText>
//                   <Para>
//                     English Cafe has quickly become one of the primary hubs to
//                     learn English online for students of all backgrounds and
//                     walks of life. Our unique approach to English education
//                     involves curating learning methods that fit the habits of
//                     our students. We have realized that placing students in an
//                     ideal learning environment enables them to absorb knowledge
//                     effectively. That is why our lessons have become swift and
//                     simple for students to grasp and retain in the long-run.
//                     With{" "}
//                     <a href="https://englishcafeonline.com/">
//                       the best English learning app
//                     </a>
//                     , our student-centered approach has yielded tremendous and
//                     lasting results and we intend to keep at it.
//                   </Para>
//                   <Para className="wepave">
//                     There is this feeling amongst students that English is a
//                     complicated and terrifying language to master. That does not
//                     have to be the case, and we make sure that our students
//                     understand that and we encourage them to learn English
//                     online. We invest time into dispelling misconceptions and
//                     empowering our students into braving their fears and
//                     improving their skills with the best English learning app.
//                     Challenges make a person strong, and that is part of our
//                     philosophy here at English Café .
//                   </Para>
//                 </LeftSection>
//                 <RightSection>
//                   <img src={aboutImg} alt="image" />
//                 </RightSection>
//                 <PhotosMob>
//                   <ImgContainer>
//                     <img src={grp} alt="img" />
//                   </ImgContainer>
//                 </PhotosMob>
//               </CoverTop>
//               <Para className="wepavetab">
//                 We don’t claim to make you Tharoor or Shakespeare in a span of 2
//                 months. What we can promise you is a strong foothold from which
//                 you can begin your journey into mastering the English language
//                 with ease.
//               </Para>
//               <Para>
//                 Whether you are a student, a working professional, employee,
//                 homemaker or an entrepreneur,{" "}
//                 <a href="https://englishcafeonline.com/">
//                   learn English online.
//                 </a>{" "}
//                 English Cafe welcomes you aboard our Language-learning vessel
//                 with open arms with best English learning app. Our experienced
//                 trainers work hard to construct lesson plans that are intended
//                 to build your confidence and communication skills
//                 simultaneously. As the English language undergoes various
//                 changes with the times, our trainers vow to stay vigilant to
//                 provide comprehensive and updated lessons for students to take
//                 to heart.
//               </Para>
//               <Para>
//                 With our dedication to excellence, we intend to assure each and
//                 every student that walks alongside us that they will be able to
//                 strut, then run and soar with their command over the English
//                 Language.
//               </Para>
//               <TitleText>Mission & Value Proposition</TitleText>
//               <Para>
//                 At English Cafe, we simplify English for learners at every
//                 level. We solve the common worry that speaking English is hard
//                 or scary. Our mission is to make English learning accessible to
//                 all. We serve students, job seekers, homemakers, and
//                 professionals who want clear, practical English skills for real
//                 life. Our goal is to make you speak English fluently with
//                 confidence.
//               </Para>
//               <Para>
//                 We offer{" "}
//                 <a href="https://englishcafeonline.com/">
//                   English speaking course for beginners
//                 </a>{" "}
//                 designed to build basics as well as those who knew English to
//                 enhance fluency. We turn fear into skill. No more shy or
//                 silence. Our learners speak, listen and connect with ease. You
//                 learn in your time from anywhere. Through our spoken English
//                 classes online, we bring expert guidance right to your screen.
//                 You learn from caring trainers who tailor practice to your
//                 goals.
//               </Para>
//               <Para>
//                 We value kindness, patience and real results. We believe that
//                 every learner can master English with the right care and focus.
//                 We aim to help people to unlock new pathways like a career
//                 growth, travel ease or global connection. We stand by your side
//                 as you speak your first English sentence, build your first
//                 presentation, or take your first interview.
//               </Para>
//               <TitleText>Who We Help</TitleText>
//               <Para>
//                 At English Cafe, we help people from all walks of life speak
//                 English with ease and confidence. We understand that each
//                 learner is different. That’s why we offer flexible{" "}
//                 <a href="https://englishcafeonline.com/">
//                   English training classes in Calicut
//                 </a>{" "}
//                 designed to meet unique needs and goals.
//               </Para>
//               <Para>
//                 Are you new to English? Our English speaking course for
//                 beginners helps you speak from the very first lesson. We use
//                 simple words, real-world practice, and friendly guidance to help
//                 you grow fast.
//               </Para>
//               <Para>
//                 We also help working professionals who want to speak fluently at
//                 the office or in meetings. Our courses help you on tone,
//                 grammar, and real-time conversation skills. With each class, you
//                 grow more clear and confident.
//               </Para>
//               <Para>
//                 If you're planning to study or work abroad, we prepare you for
//                 success. We can guide you like an{" "}
//                 <a href="https://englishcafeonline.com/">
//                   IELTS coaching centre
//                 </a>{" "}
//                 if you’re aiming for IELTS.
//               </Para>
//               <Para>
//                 Whether you’re just starting or want to polish your skills, we
//                 are here to help. Our English training classes are simple,
//                 flexible, and focused on your growth. Learn at your pace, in
//                 your space.
//               </Para>
//               <Para>
//                 Homemakers, job seekers, students, and entrepreneurs also find a
//                 space at English Cafe. We offer comfort, support and result.
//               </Para>
//               <Para>
//                 No matter your age or background, English Cafe helps you speak
//                 with courage and clarity
//               </Para>
//               <TitleText>Why Choose English Cafe?</TitleText>
//               <Para>
//                 At English Cafe, we offer flexible and focused training for all
//                 English learners. Whether you're just starting or want to
//                 fine-tune your English speaking skills, we are here for you.
//                 From personalized English speaking course for beginners to
//                 expert-led IELTS coaching centre programs, we help you grow at
//                 your own pace. Our mission is simple: make it easy to learn
//                 English online with confidence. Here's what makes us different.
//               </Para>

//               <CardsWrapper>
//                 {cardsData.map((card, index) => (
//                   <Card key={index}>
//                     <h3>{card.title}</h3>
//                     <p>{card.description}</p>
//                   </Card>
//                 ))}
//               </CardsWrapper>

//               <Photos>
//                 <ImgContainer>
//                   <img src={grp} alt="img" />
//                 </ImgContainer>
//               </Photos>
//             </Wrapper>
//           </Content>
//         </Fade>
//         <CallBanner>
//           <span>Our Call Center :</span>
//           <a href="tel:+91 7907139138">+91 7907139138</a>
//         </CallBanner>
//       </Container>
//       <Footer />
//     </>
//   );
// }

// export default AboutPage;

// const Container = styled.div``;
// const TitleText = styled.h1`
//   color: var(--blue);
//   font-family: "mont-bold";
//   margin-top: 20px;
//   @media all and (max-width: 480px) {
//     font-size: 22px;
//   }
// `;
// const Wrapper = styled.div`
//   width: 70%;
//   margin: 0 auto;
//   @media all and (max-width: 1440px) {
//     width: 80%;
//   }
//   @media all and (max-width: 768px) {
//     flex-direction: column;
//   }
// `;
// const Banner = styled.div`
//   background: url(${bg});
//   height: 62vh;
//   background-repeat: no-repeat;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   @media all and (max-width: 1560px) {
//     background-position: center;
//   }
//   @media all and (max-width: 1280px) {
//     background-position: 30%;
//   }
//   @media all and (max-width: 768px) {
//     background: url(${tab_bg});
//   }
//   @media all and (max-width: 480px) {
//     background: url(${mob_bg});
//     background-position: center;
//     background-size: contain;
//   }
// `;
// const Content = styled.div`
//   padding: 40px 0;
// `;
// const Text = styled.h1`
//   color: #fff;
//   font-family: mont-medium;
//   font-size: 50px;
//   margin-left: 350px;
//   margin-top: 150px;
//   @media all and (max-width: 768px) {
//     display: none;
//   }
// `;
// const SubTitle = styled.h4`
//   color: var(--blue);
//   border-bottom: 1px solid var(--blue);
//   padding-bottom: 10px;
//   display: inline-block;
//   font-family: "mont-medium";
//   margin-bottom: 60px;
//   @media all and (max-width: 480px) {
//     margin-bottom: 10px;
//   }
// `;
// const CallBanner = styled.div`
//   background-color: #f5f4f5;
//   padding: 30px 0;
//   text-align: center;
//   span {
//     color: #d92119;
//     font-size: 30px;
//     @media all and (max-width: 480px) {
//       font-size: 18px;
//     }
//   }
//   a {
//     margin-left: 10px;
//     color: var(--blue);
//     font-family: "mont-bold";
//     text-decoration: none;
//     font-size: 35px;
//     @media all and (max-width: 480px) {
//       font-size: 20px;
//     }
//   }
//   @media all and (max-width: 480px) {
//     padding: 20px 0;
//   }
// `;

// const Para = styled.p`
//   font-size: 16px;
//   line-height: 32px;
//   &.wepave {
//     @media all and (max-width: 1280px) {
//       display: none;
//     }
//   }
//   &.wepavetab {
//     display: none;
//     @media all and (max-width: 1280px) {
//       display: block;
//     }
//   }
//   @media all and (max-width: 1700px) {
//     font-size: 14px;
//   }
// `;
// const LeftSection = styled.div`
//   width: 50%;
//   @media all and (max-width: 768px) {
//     width: 100%;
//   }
// `;
// const CoverTop = styled.div`
//   display: flex;
//   @media all and (max-width: 768px) {
//     flex-direction: column-reverse;
//   }
// `;
// const RightSection = styled.div`
//   width: 50%;
//   @media all and (max-width: 768px) {
//     width: 100%;
//   }
//   @media all and (max-width: 480px) {
//     display: none;
//   }
// `;
// const Photos = styled.div`
//   margin-top: 30px;
//   width: 94%;
//   @media all and (max-width: 480px) {
//     display: none;
//   }
// `;
// const PhotosMob = styled.div`
//   display: none;
//   margin-top: 30px;
//   width: 100%;
//   @media all and (max-width: 480px) {
//     display: block;
//     margin-top: 0;
//   }
// `;
// const ImgContainer = styled.div`
//   width: 80%;
//   margin: 0 auto;
//   @media all and (max-width: 480px) {
//     width: 100%;
//   }
// `;

// const CardsWrapper = styled.div`
//   display: grid;
//   gap: 20px;
//   margin-top: 40px;

//   /* Default: 2 cards per row */
//   grid-template-columns: repeat(2, 1fr);

//   @media (min-width: 1024px) {
//     /* 4 cards per row on large screens */
//     grid-template-columns: repeat(4, 1fr);
//   }

//   @media (max-width: 640px) {
//     /* 1 card per row on very small screens (optional tweak) */
//     grid-template-columns: 1fr;
//     gap: 10px;
//   }
// `;
// const Card = styled.div`
//   border: 1px solid #e0e0e0;
//   border-radius: 16px;
//   padding: 24px 20px;
//   background: #ffffff;
//   transition: all 0.3s ease;
//   text-align: center;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

//   h3 {
//     font-size: 18px;
//     margin-bottom: 12px;
//     color: #0c7379;
//     font-weight: 600;
//   }

//   p {
//     font-size: 15px;
//     color: #555555;
//     line-height: 1.5;
//   }

//   &:hover {
//     transform: translateY(-4px);
//     box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
//     border-color: #0c7379;
//   }

//   @media (max-width: 640px) {
//     padding: 16px 14px;

//     h3 {
//       font-size: 16px;
//     }

//     p {
//       font-size: 14px;
//     }
//   }
// `;

import React from "react";
import { Fade, Zoom } from "react-reveal";
import { Helmet } from "react-helmet";

import Header from "../../includes/home/Header";
import styled, { keyframes } from "styled-components";
import Footer from "../../includes/home/Footer";
import bg from "../../../assets/images/about/AboutBanner.jpg";
import tab_bg from "../../../assets/images/about/Banner_Tab.jpg";
import mob_bg from "../../../assets/images/about/Banner_Mob.jpg";
import aboutImg from "../../../assets/images/about/Aboutimage.jpg";
import grp from "../../../assets/images/about/grp.jpg";

const cardsData = [
  {
    title: "Tailored Courses for All Learners",
    description:
      "We offer English training classes for every level—beginner to advance. Whether you are a student, a job seeker or a homemaker, we provide training to accomplish your goals. Our step-by-step approach makes learning smooth and stress-free.",
  },
  {
    title: "Trusted IELTS Coaching Centre",
    description:
      "We offer IELTS training for academic and general exams. We offer IELTS Coaching Centre like practice tests and live sessions. You'll build the skills needed for reading, writing, speaking, and listening. With us, you can prepare well and aim high.",
  },
  {
    title: "Beginner-Friendly Spoken English",
    description:
      "New to English? Our English speaking course for beginners helps you build a strong base. From greetings to full talks, we guide you through real-life situations. Our trainers make sure you speak with ease and confidence",
  },
  {
    title: "Flexible Online Learning",
    description:
      "Want to learn English online on your schedule? Our spoken English classes online and English language course online give you that freedom. Learn from anywhere with expert trainers who keep you motivated and moving forward.",
  },
];

function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About English Cafe | English Training Centre in Calicut</title>
        <meta
          name="description"
          content="At English Cafe, we welcome you to boost your confidence and communication skills through our expertly crafted lessons. Join us now!"
        ></meta>
      </Helmet>
      <Container>
        <Banner>
          <Header />
          <BannerOverlay />
          <Zoom>
            <Text>About</Text>
          </Zoom>
        </Banner>
        <Fade bottom>
          <Content>
            <Wrapper>
              <SubTitle>About</SubTitle>
              <CoverTop>
                <LeftSection>
                  <TitleText>English Cafe Stands Out Because...?</TitleText>
                  <Para>
                    English Cafe has quickly become one of the primary hubs to
                    learn English online for students of all backgrounds and
                    walks of life. Our unique approach to English education
                    involves curating learning methods that fit the habits of
                    our students. We have realized that placing students in an
                    ideal learning environment enables them to absorb knowledge
                    effectively. That is why our lessons have become swift and
                    simple for students to grasp and retain in the long-run.
                    With{" "}
                    <StyledLink href="https://englishcafeonline.com/">
                      the best English learning app
                    </StyledLink>
                    , our student-centered approach has yielded tremendous and
                    lasting results and we intend to keep at it.
                  </Para>
                  <Para className="wepave">
                    There is this feeling amongst students that English is a
                    complicated and terrifying language to master. That does not
                    have to be the case, and we make sure that our students
                    understand that and we encourage them to learn English
                    online. We invest time into dispelling misconceptions and
                    empowering our students into braving their fears and
                    improving their skills with the best English learning app.
                    Challenges make a person strong, and that is part of our
                    philosophy here at English Café .
                  </Para>
                </LeftSection>
                <RightSection>
                  <ImageContainer>
                    <img src={aboutImg} alt="About English Cafe" />
                  </ImageContainer>
                </RightSection>
                <PhotosMob>
                  <ImgContainer>
                    <img src={grp} alt="English Cafe Group" />
                  </ImgContainer>
                </PhotosMob>
              </CoverTop>
              <Para className="wepavetab">
                We don't claim to make you Tharoor or Shakespeare in a span of 2
                months. What we can promise you is a strong foothold from which
                you can begin your journey into mastering the English language
                with ease.
              </Para>
              <Para>
                Whether you are a student, a working professional, employee,
                homemaker or an entrepreneur,{" "}
                <StyledLink href="https://englishcafeonline.com/">
                  learn English online.
                </StyledLink>{" "}
                English Cafe welcomes you aboard our Language-learning vessel
                with open arms with best English learning app. Our experienced
                trainers work hard to construct lesson plans that are intended
                to build your confidence and communication skills
                simultaneously. As the English language undergoes various
                changes with the times, our trainers vow to stay vigilant to
                provide comprehensive and updated lessons for students to take
                to heart.
              </Para>
              <Para>
                With our dedication to excellence, we intend to assure each and
                every student that walks alongside us that they will be able to
                strut, then run and soar with their command over the English
                Language.
              </Para>
              
              <SectionDivider />
              
              <TitleText>Mission & Value Proposition</TitleText>
              <Para>
                At English Cafe, we simplify English for learners at every
                level. We solve the common worry that speaking English is hard
                or scary. Our mission is to make English learning accessible to
                all. We serve students, job seekers, homemakers, and
                professionals who want clear, practical English skills for real
                life. Our goal is to make you speak English fluently with
                confidence.
              </Para>
              <Para>
                We offer{" "}
                <StyledLink href="https://englishcafeonline.com/">
                  English speaking course for beginners
                </StyledLink>{" "}
                designed to build basics as well as those who knew English to
                enhance fluency. We turn fear into skill. No more shy or
                silence. Our learners speak, listen and connect with ease. You
                learn in your time from anywhere. Through our spoken English
                classes online, we bring expert guidance right to your screen.
                You learn from caring trainers who tailor practice to your
                goals.
              </Para>
              <Para>
                We value kindness, patience and real results. We believe that
                every learner can master English with the right care and focus.
                We aim to help people to unlock new pathways like a career
                growth, travel ease or global connection. We stand by your side
                as you speak your first English sentence, build your first
                presentation, or take your first interview.
              </Para>
              
              <SectionDivider />
              
              <TitleText>Who We Help</TitleText>
              <Para>
                At English Cafe, we help people from all walks of life speak
                English with ease and confidence. We understand that each
                learner is different. That's why we offer flexible{" "}
                <StyledLink href="https://englishcafeonline.com/">
                  English training classes in Calicut
                </StyledLink>{" "}
                designed to meet unique needs and goals.
              </Para>
              <Para>
                Are you new to English? Our English speaking course for
                beginners helps you speak from the very first lesson. We use
                simple words, real-world practice, and friendly guidance to help
                you grow fast.
              </Para>
              <Para>
                We also help working professionals who want to speak fluently at
                the office or in meetings. Our courses help you on tone,
                grammar, and real-time conversation skills. With each class, you
                grow more clear and confident.
              </Para>
              <Para>
                If you're planning to study or work abroad, we prepare you for
                success. We can guide you like an{" "}
                <StyledLink href="https://englishcafeonline.com/">
                  IELTS coaching centre
                </StyledLink>{" "}
                if you're aiming for IELTS.
              </Para>
              <Para>
                Whether you're just starting or want to polish your skills, we
                are here to help. Our English training classes are simple,
                flexible, and focused on your growth. Learn at your pace, in
                your space.
              </Para>
              <Para>
                Homemakers, job seekers, students, and entrepreneurs also find a
                space at English Cafe. We offer comfort, support and result.
              </Para>
              <Para>
                No matter your age or background, English Cafe helps you speak
                with courage and clarity
              </Para>
              
              <SectionDivider />
              
              <TitleText>Why Choose English Cafe?</TitleText>
              <Para>
                At English Cafe, we offer flexible and focused training for all
                English learners. Whether you're just starting or want to
                fine-tune your English speaking skills, we are here for you.
                From personalized English speaking course for beginners to
                expert-led IELTS coaching centre programs, we help you grow at
                your own pace. Our mission is simple: make it easy to learn
                English online with confidence. Here's what makes us different.
              </Para>

              <CardsWrapper>
                {cardsData.map((card, index) => (
                  <Card key={index} delay={index * 0.1}>
                    <CardIcon>
                      {index === 0 && "🎯"}
                      {index === 1 && "🏆"}
                      {index === 2 && "💬"}
                      {index === 3 && "📱"}
                    </CardIcon>
                    <CardTitle>{card.title}</CardTitle>
                    <CardDescription>{card.description}</CardDescription>
                  </Card>
                ))}
              </CardsWrapper>

              <Photos>
                <ImgContainer>
                  <img src={grp} alt="English Cafe Team" />
                </ImgContainer>
              </Photos>
            </Wrapper>
          </Content>
        </Fade>
        <CallBanner>
          <CallBannerContent>
            <CallIcon>📞</CallIcon>
            <CallText>
              <CallLabel>Our Call Center:</CallLabel>
              <CallNumber href="tel:+91 7907139138">+91 7907139138</CallNumber>
            </CallText>
          </CallBannerContent>
        </CallBanner>
      </Container>
      <Footer />
    </>
  );
}

export default AboutPage;

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

// Styled Components
const Container = styled.div`
  position: relative;
`;

const BannerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(12, 115, 121, 0.3) 0%,
    rgba(217, 33, 25, 0.2) 100%
  );
  pointer-events: none;
`;

const Banner = styled.div`
  background: url(${bg});
  height: 62vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
  }
  
  @media all and (max-width: 1560px) {
    background-position: center;
  }
  @media all and (max-width: 1280px) {
    background-position: 30%;
  }
  @media all and (max-width: 768px) {
    background: url(${tab_bg});
    background-size: cover;
    background-position: center;
  }
  @media all and (max-width: 480px) {
    background: url(${mob_bg});
    background-position: center;
    background-size: cover;
  }
`;

const Text = styled.h1`
  color: #fff;
  font-family: 'mont-medium', sans-serif;
  font-size: 50px;
  margin-left: 350px;
  margin-top: 150px;
  position: relative;
  z-index: 2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  animation: ${fadeInUp} 1s ease-out;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #0c7379, #d92119);
    border-radius: 2px;
  }
  
  @media all and (max-width: 768px) {
    display: none;
  }
`;

const Content = styled.div`
  padding: 60px 0;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #fafafa 50%,
    #ffffff 100%
  );
`;

const Wrapper = styled.div`
  width: 70%;
  margin: 0 auto;
  animation: ${fadeInUp} 0.8s ease-out;
  
  @media all and (max-width: 1440px) {
    width: 80%;
  }
  @media all and (max-width: 768px) {
    width: 90%;
  }
  @media all and (max-width: 480px) {
    width: 95%;
  }
`;

const SubTitle = styled.h4`
  color: var(--blue, #0c7379);
  border-bottom: 3px solid transparent;
  background: linear-gradient(90deg, #0c7379, #d92119) bottom / 100% 3px no-repeat;
  padding-bottom: 15px;
  display: inline-block;
  font-family: "mont-medium", sans-serif;
  margin-bottom: 60px;
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, #0c7379, #d92119);
    border-radius: 2px;
  }
  
  @media all and (max-width: 480px) {
    margin-bottom: 30px;
    font-size: 20px;
  }
`;

const TitleText = styled.h1`
  color: var(--blue, #0c7379);
  font-family: "mont-bold", sans-serif;
  margin: 40px 0 20px 0;
  font-size: 32px;
  line-height: 1.2;
  position: relative;
  animation: ${slideInLeft} 0.6s ease-out;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #0c7379, #d92119);
    border-radius: 1.5px;
  }
  
  @media all and (max-width: 480px) {
    font-size: 24px;
    margin: 30px 0 15px 0;
  }
`;

const Para = styled.p`
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
  color: #333;
  text-align: justify;
  
  &.wepave {
    @media all and (max-width: 1280px) {
      display: none;
    }
  }
  &.wepavetab {
    display: none;
    @media all and (max-width: 1280px) {
      display: block;
    }
  }
  
  @media all and (max-width: 1700px) {
    font-size: 15px;
  }
  @media all and (max-width: 480px) {
    font-size: 14px;
    line-height: 1.6;
  }
`;

const StyledLink = styled.a`
  color: #0c7379;
  text-decoration: none;
  font-weight: 600;
  position: relative;
  transition: all 0.3s ease;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, #0c7379, #d92119);
    transition: width 0.3s ease;
  }
  
  &:hover {
    color: #d92119;
    
    &::after {
      width: 100%;
    }
  }
`;

const CoverTop = styled.div`
  display: flex;
  gap: 40px;
  margin-bottom: 40px;
  
  @media all and (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 20px;
  }
`;

const LeftSection = styled.div`
  width: 55%;
  
  @media all and (max-width: 768px) {
    width: 100%;
  }
`;

const RightSection = styled.div`
  width: 45%;
  
  @media all and (max-width: 768px) {
    width: 100%;
  }
  @media all and (max-width: 480px) {
    display: none;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.3s ease;
  }
  
  &:hover img {
    transform: scale(1.05);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(12, 115, 121, 0.1) 0%,
      rgba(217, 33, 25, 0.1) 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    opacity: 1;
  }
`;

const SectionDivider = styled.div`
  height: 2px;
  background: linear-gradient(90deg, transparent, #0c7379, #d92119, transparent);
  margin: 50px 0;
  border-radius: 1px;
`;

const CardsWrapper = styled.div`
  display: grid;
  gap: 25px;
  margin: 50px 0;
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 30px 25px;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: 1px solid #f0f0f0;
  animation: ${fadeInUp} 0.6s ease-out ${props => props.delay}s both;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s ease;
  }
  
  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 40px rgba(12, 115, 121, 0.15);
    border-color: #0c7379;
    
    &::before {
      left: 100%;
    }
  }
  
  &:nth-child(odd) {
    background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  }
  
  &:nth-child(even) {
    background: linear-gradient(135deg, #ffffff 0%, #fef8f8 100%);
  }

  @media (max-width: 640px) {
    padding: 25px 20px;
  }
`;

const CardIcon = styled.div`
  font-size: 40px;
  margin-bottom: 20px;
  animation: ${pulse} 2s ease-in-out infinite;
  
  @media (max-width: 640px) {
    font-size: 35px;
    margin-bottom: 15px;
  }
`;

const CardTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 15px;
  color: #0c7379;
  font-weight: 700;
  line-height: 1.3;
  font-family: "mont-bold", sans-serif;
  
  @media (max-width: 640px) {
    font-size: 18px;
    margin-bottom: 12px;
  }
`;

const CardDescription = styled.p`
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 0;
  
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const Photos = styled.div`
  margin-top: 50px;
  width: 100%;
  
  @media all and (max-width: 480px) {
    display: none;
  }
`;

const PhotosMob = styled.div`
  display: none;
  margin-top: 30px;
  width: 100%;
  
  @media all and (max-width: 480px) {
    display: block;
    margin-top: 20px;
  }
`;

const ImgContainer = styled.div`
  width: 85%;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.3s ease;
  }
  
  &:hover img {
    transform: scale(1.02);
  }
  
  @media all and (max-width: 480px) {
    width: 100%;
    border-radius: 15px;
  }
`;

const CallBanner = styled.div`
  background: linear-gradient(135deg, #f5f4f5 0%, #e8f4f5 100%);
  padding: 40px 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #0c7379, #d92119);
  }
  
  @media all and (max-width: 480px) {
    padding: 30px 0;
  }
`;

const CallBannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  
  @media all and (max-width: 480px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const CallIcon = styled.div`
  font-size: 35px;
  animation: ${pulse} 2s ease-in-out infinite;
  
  @media all and (max-width: 480px) {
    font-size: 25px;
  }
`;

const CallText = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  
  @media all and (max-width: 480px) {
    flex-direction: column;
    gap: 5px;
    text-align: center;
  }
`;

const CallLabel = styled.span`
  color: #d92119;
  font-size: 28px;
  font-weight: 600;
  font-family: "mont-medium", sans-serif;
  
  @media all and (max-width: 480px) {
    font-size: 18px;
  }
`;

const CallNumber = styled.a`
  color: var(--blue, #0c7379);
  font-family: "mont-bold", sans-serif;
  text-decoration: none;
  font-size: 32px;
  font-weight: 700;
  transition: all 0.3s ease;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 0;
    height: 3px;
    background: linear-gradient(90deg, #0c7379, #d92119);
    transition: width 0.3s ease;
  }
  
  &:hover {
    color: #d92119;
    transform: scale(1.05);
    
    &::after {
      width: 100%;
    }
  }
  
  @media all and (max-width: 480px) {
    font-size: 20px;
  }
`;